import { NOCSearch } from "../../services/molecules/NOC/Search";
import { useQuery } from "react-query";

const useNOCExcelSearch = (tenantId, authority, tehsil, district, villageList, config = {}) => {
  return useQuery(
    ["DEPARTMENT_NOC", tehsil, villageList, district],
    () => NOCSearch.departmentNoc(tenantId, { authority, tehsil, district, villageList }),
    config
  );
};

export default useNOCExcelSearch;
